import React from 'react';
import { Modal, Form, Popover, Alert, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import ExclamationCircleIcon from '../../Icons/ExclamationCircleIcon';
import RichTextEditor from '../Editor/RichTextEditor';
import config from '../../Config/Config';
import BulkCandidatesDownloadFilterInfo from '../BulkCandidatesCriteria/BulkCandidatesDownloadFilterInfo';
import './MessageComposer.scss';
import ConnectTemplateSelect from '../JobSettings/ConnectTemplateSelect';
import CreditInfoAlert from '../CreditInfo/CreditInfoAlert';
import { UserAlertWithWrapper } from '../UserAlerts/UserAlerts';
import { getInfoAlertMessage } from '../Utils/SmsUtils';
import SmsCounter from '../Connect/SmsCounter/SmsCounter';
import textTemplateMessages from '../Connect/BaseTemplateForm/CreateTextTemplate/messages';
import { getPlainTextFromHTML } from '../../Utils/TextUtils';
import MessageWindowTemplateConsentNote from './MessageWindowTemplateConsentNote';
import message from './MessageComposerMessage';
import SpamAlertText from '../Common/SpamTextAlert/SpamTextAlert';

class MessageComposer extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.addTags = this.addTags.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { visible, fetchMessageTemplates } = this.props;

    const prevVisibility = _.get(prevProps, 'visible', false);
    if (prevVisibility === false && visible === true) {
      fetchMessageTemplates({ From: 0, Size: 10 });
    }
  }

  addTags(tag) {
    this.myRef.current.addTags(tag, false);
  }

  replaceWithPlainText = plainBody => {
    const quill = this.myRef.current?.quillRef;
    if (!quill) return;
    quill.setText(plainBody);
    quill.setSelection(quill.getLength(), 0);
  };

  render() {
    const {
      visible,
      onCancel,
      eventCallbacks,
      form,
      currentValues,
      mergeTags = [],
      // consentRequire = false,
      messageTemplateIds,
      messageTemplatesById,
      messageTemplatesCount,
      fetchMessageTemplates,
      selectedMessageTemplateId,
      selectedActiveCandidateCount,
      currentUser,
      credits,
      onCloseCreditInfoAlert,
      isPaidJobServiceEnabled,
      candidateDownloadFilterConfig,
      candidateCommunicationFilterConfig,
      communicationDisabledMessage,
      availableCredits,
      featureToggleList,
      userConfig,
      isJunkWordFound,
      junkWords,
      consentText,
    } = this.props;

    const availableTextCredits = availableCredits?.SMS?.AvailableCredits;
    const isPanelContentDisable = !availableTextCredits || availableCredits === 'N/A';

    // const isConsentMessage = true;
    const isConsentMessage = false;
    const { validateFields } = form;
    const { isConsent, messageInputValue } = currentValues;
    const regex = /\n$/gi;
    let isDisable = true;
    const selectedMessageTemplateName = _.get(messageTemplatesById, [selectedMessageTemplateId, 'Name'], null);

    const handleSubmit = event => {
      event.preventDefault();
      validateFields(err => {
        if (!err) {
          const text = this.myRef.current.quillRef.getText().trim().replace(regex, '');
          eventCallbacks.onSend(text);
        }
      });
    };

    const popoverContent = (
      <div className="tags-popover-content">
        {mergeTags.map(mergeTag => (
          <div className="merge-tag" onClick={() => this.addTags(mergeTag)} role="presentation" key={mergeTag.Key}>
            + {mergeTag.DisplayName}
          </div>
        ))}
      </div>
    );

    const addMergeTags = (
      <Popover content={popoverContent} placement="right" trigger="click">
        <div className="message-composer-merge-tags">
          <FormattedMessage {...message.mergeTagsLabel} />
        </div>
      </Popover>
    );

    if (this.myRef.current) {
      isDisable = this.myRef.current.quillRef.getText().trim().replace(regex, '').length === 0;
    }
    const {
      MessageConsentTemplateCreation: { IsEnabled: messageConsentTemplateCreationEnabled },
    } = featureToggleList;
    const isEditorBodyDisabled = isConsentMessage || !messageConsentTemplateCreationEnabled;
    const editorText = this.myRef.current?.quillRef?.getText() ?? getPlainTextFromHTML(messageInputValue ?? '');
    const plainMessageBody = _.trimEnd(editorText.trim(), '\n');
    // aryaconnect appends the org's consent footer, or its English default, only to consent templates.
    const consentTextForCount = consentText || textTemplateMessages.textConsentMessage.defaultMessage;

    return (
      <div>
        <Modal
          title={<FormattedMessage {...message.messageComposerTitleLabel} />}
          visible={visible}
          onOk={handleSubmit}
          onCancel={onCancel}
          okText={<FormattedMessage {...message.sendLabel} />}
          className="bulkMessageModalBody"
          okButtonProps={{
            disabled: isConsentMessage ? false : isDisable,
          }}
        >
          {communicationDisabledMessage ? (
            <UserAlertWithWrapper
              header={communicationDisabledMessage.header}
              content={communicationDisabledMessage.body}
            />
          ) : (
            <Form onSubmit={handleSubmit} className="connect-message-form">
              <div id="muti-select-message-window " style={{ cursor: isPanelContentDisable ? 'not-allowed' : '' }}>
                <CreditInfoAlert
                  credits={credits}
                  onCloseCreditInfoAlert={onCloseCreditInfoAlert}
                  selectedActiveCandidateCount={selectedActiveCandidateCount}
                  currentUser={currentUser}
                  isPaidJobServiceEnabled={isPaidJobServiceEnabled}
                  availableCredits={availableCredits}
                  userConfig={userConfig}
                  showCreditInfoAlert
                />
                <Alert message={<FormattedMessage {...message.consentMessageLabel} />} type="info" showIcon />
                {getInfoAlertMessage(availableTextCredits)}
                <div
                  className={`multi-select-message-window-flex-items ${
                    isPanelContentDisable ? 'messageTextCreditsNotAvailable' : ''
                  }`}
                >
                  <ConnectTemplateSelect
                    cssClassname="candidate-multi-select-message-template-select"
                    templatesById={messageTemplatesById}
                    templateIds={messageTemplateIds}
                    templatesCount={messageTemplatesCount}
                    fetchTemplates={fetchMessageTemplates}
                    selectedTemplateId={selectedMessageTemplateId}
                    selectedTemplateName={selectedMessageTemplateName}
                    placeholderValue={<FormattedMessage {...message.connectTemplatePlaceHolderLabel} />}
                    onChange={eventCallbacks.onTemplateSelect}
                    isDisabled={isConsentMessage}
                    isClearFieldAllowed
                  />
                  {isConsentMessage || isEditorBodyDisabled ? null : addMergeTags}
                  {/* <img
            id="connect-aryacredit-icon"
            src={`${process.env.PUBLIC_URL}/static/images/aryacredit.svg`}
            alt="Arya credit"
          />
          <span>
            Credits Remaining: <b>534</b>
          </span> */}
                </div>

                <div
                  className={`muti-select-message-window-flex-items ${
                    isPanelContentDisable ? 'messageTextCreditsNotAvailable' : ''
                  }`}
                >
                  <div className="message-textarea">
                    <RichTextEditor
                      className="mail-editor"
                      editorContent={{
                        htmlContent: isConsentMessage ? config.consentTemplateBody : currentValues.messageInputValue,
                      }}
                      onChange={eventCallbacks.onUpdateMessage}
                      mergeTags={mergeTags}
                      ref={this.myRef}
                      showToolbar={false}
                      disabled={isEditorBodyDisabled}
                      readonly={isEditorBodyDisabled}
                      highlightSmsSpecialCharacters
                      editorContext="Message"
                    />
                    {isJunkWordFound ? (
                      <SpamAlertText
                        style={{ paddingLeft: '15px' }}
                        alertStyle={{ width: '425px' }}
                        junkWords={junkWords}
                        placement="right"
                      />
                    ) : null}
                    <div className="message-composer-sms-counter">
                      <SmsCounter
                        body={plainMessageBody}
                        consentText={consentTextForCount}
                        includeConsent={!!isConsent}
                        onReplace={isEditorBodyDisabled ? undefined : this.replaceWithPlainText}
                        extra={
                          <Tooltip
                            zIndex={2223}
                            title={<FormattedMessage {...message.totalCharactersShownWarning} />}
                            placement="rightBottom"
                          >
                            <span>
                              <ExclamationCircleIcon />
                            </span>
                          </Tooltip>
                        }
                      />
                    </div>
                  </div>
                </div>
                {isConsent ? (
                  <div>
                    <MessageWindowTemplateConsentNote />
                    <div className="message-window-template-consent-text">{consentText}</div>
                  </div>
                ) : null}
              </div>
              <BulkCandidatesDownloadFilterInfo
                candidateDownloadFilterConfig={candidateDownloadFilterConfig}
                candidateCommunicationFilterConfig={candidateCommunicationFilterConfig}
              />
            </Form>
          )}
        </Modal>
      </div>
    );
  }
}

export default Form.create()(MessageComposer);
